// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CustomFieldFromJSON, CustomFieldToJSON, } from './';
export function CompositionRulesFromJSON(json) {
    return {
        'vintage': !exists(json, 'vintage') ? undefined : json['vintage'],
        'strategy': !exists(json, 'strategy') ? undefined : json['strategy'],
        'investorAccount': !exists(json, 'investorAccount') ? undefined : json['investorAccount'],
        'geography': !exists(json, 'geography') ? undefined : json['geography'],
        'assetClass': !exists(json, 'assetClass') ? undefined : json['assetClass'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'manager': !exists(json, 'manager') ? undefined : json['manager'],
        'fundCustomField': !exists(json, 'fundCustomField') ? undefined : json['fundCustomField'].map(CustomFieldFromJSON),
        'investorCustomField': !exists(json, 'investorCustomField') ? undefined : json['investorCustomField'].map(CustomFieldFromJSON),
        'fundBased': !exists(json, 'fundBased') ? undefined : json['fundBased'],
    };
}
export function CompositionRulesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'vintage': value.vintage,
        'strategy': value.strategy,
        'investorAccount': value.investorAccount,
        'geography': value.geography,
        'assetClass': value.assetClass,
        'currency': value.currency,
        'manager': value.manager,
        'fundCustomField': value.fundCustomField === undefined ? undefined : value.fundCustomField.map(CustomFieldToJSON),
        'investorCustomField': value.investorCustomField === undefined ? undefined : value.investorCustomField.map(CustomFieldToJSON),
        'fundBased': value.fundBased,
    };
}
